import React from 'react';

/**
 * 莱茵生命终端风格的品牌标识块(左上角)。
 *
 * - `variant="page"`:普通页面(直接压在纸白背景上)
 * - `variant="over"`:会议中叠加在视频之上,改为纸白卡片以便辨识
 * - `compact`:缩小一档,用于通话界面这类信息密集的场景
 */
export function RhineBrand({
  variant = 'page',
  compact = false,
}: {
  variant?: 'page' | 'over';
  compact?: boolean;
}) {
  const className = [
    'rhine-brand',
    variant === 'over' ? 'rhine-brand--over' : '',
    compact ? 'rhine-brand--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className} aria-hidden="true">
      <p className="rhine-brand__title">RHINE LAB</p>
      <p className="rhine-brand__sub">SYNTHESIZE&nbsp;&nbsp;&nbsp;&nbsp;INFORMATION</p>
      <p className="rhine-brand__os">
        ANALYSIS&nbsp;&nbsp;<b>OS</b>
      </p>
    </div>
  );
}

/**
 * 右下角的 POWERED BY RHINE LAB 署名与徽标。
 *
 * - `variant="over"`:叠加在视频之上,徽标会加一层纸白底衬。
 */
export function RhineSignature({ variant = 'page' }: { variant?: 'page' | 'over' }) {
  return (
    <div
      className={`rhine-signature${variant === 'over' ? ' rhine-signature--over' : ''}`}
      aria-hidden="true"
    >
      <span>
        POWERED BY <b>RHINE LAB</b>
      </span>
      <img className="rhine-signature__logo" src="/rhine/logo-black.png" alt="" />
    </div>
  );
}
